import React from 'react';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { Link } from "react-router-dom";
import Breadcrumbs from './Breadcrumbs';
import _ from '../../utils/ObjectUtils';

const TopHeader = ({
    pageName,
    topHeaderCustomTitle,
    customBreadcrumbs,
    userName,
    logout
}) => {
    const pageNameAux = generatePageHeader(pageName);
    const pageHeader = topHeaderCustomTitle ? topHeaderCustomTitle : I18n.t('routes.' + pageNameAux);
    const breadcrumbs = !_.isNilOrEmpty(customBreadcrumbs) ? customBreadcrumbs : generateBreadcrumbs(pageName);

    return (
        <div id="top-header-wrap">
            <div className="top-header-content">
                <div className="top-header-page">
                    <span className="page-name">
                        {pageHeader}
                    </span>
                    <Breadcrumbs
                        paths={breadcrumbs}
                    />
                </div>
                <div className="top-header-user">
                    <div className="top-header-username">
                        <Link to="/personalArea">
                            {userName}
                        </Link>
                    </div>
                    <div className="top-header-logout">
                        <span onClick={() => logout(false)}>
                            {I18n.t('auth.signOut')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
};

function generatePageHeader(pageName) {
    let pageNameAux = pageName;
    pageNameAux = pageNameAux.substring(1, pageNameAux.length);
    if (pageNameAux.lastIndexOf('/') === pageNameAux.length) {
        pageNameAux = pageNameAux.substring(0, pageNameAux.length - 1)
    }
    let tabPosition = pageNameAux.lastIndexOf('/');
    if (tabPosition !== -1) {
        let pageNameBegin = pageNameAux.substring(0, tabPosition);
        let pageNameEnd = pageNameAux.substring(tabPosition + 1, pageNameAux.length);
        if (pageNameEnd === "create") {
            pageNameAux = pageNameBegin + "create"
        } else {
            pageNameAux = pageNameBegin + "details"
        }
    }
    return pageNameAux;
}

function generateBreadcrumbs(pageName) {
    let breadcrumbLinkAccumulator = '';
    let breadcrumbArrayResult = [];

    const breadcrumbArray = pageName.split('/').filter(s => !_.isEmpty(s));
  
    breadcrumbArray.forEach(breadcrumb => {
        breadcrumbLinkAccumulator += '/' + breadcrumb;

        breadcrumbArrayResult.push({
            name: I18n.t('routes.' + breadcrumb),
            link: breadcrumbLinkAccumulator
        });
    });

    //Some pages need a special breadcrumbs format
    //Pass the breadcrumbs through a 'normalizer' function so that custom rules may be applied
    breadcrumbArrayResult = normalizeBreadcrumbs(breadcrumbArrayResult);

    return breadcrumbArrayResult;
}

//Custom rules for breadcrumbs should go in here
function normalizeBreadcrumbs(breadcrumbs) {
    let refactoredBreadcrumbs = [...breadcrumbs];

    // ---Rule 1---
    // If the first item is 'dashboard', return an empty array
    // Dashboard page does not need breadcrumbs
    if (refactoredBreadcrumbs[0].name === I18n.t('routes.dashboard')) return [];

    // ---Rule 2---
    // If you are in an interface page you will have this: [Terminals > terminalId > Interfaces > interfaceId]
    // 'Interfaces' page does not exist so we need to remove it 
    if(refactoredBreadcrumbs[0].name === 'terminals') return refactoredBreadcrumbs.filter(b => b.name !== 'interfaces');

    return refactoredBreadcrumbs;
}

TopHeader.propTypes = {
    pageName: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    logout: PropTypes.func.isRequired
};

export default TopHeader;
